var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3928 6.57312C16.0282 5.93777 17.0583 5.93776 17.6936 6.57311C18.329 7.20846 18.329 8.23857 17.6936 8.87392L14.3649 12.2026L17.668 15.5057C18.2722 16.1099 18.2722 17.0895 17.668 17.6938C17.0637 18.298 16.0841 18.298 15.4799 17.6938L12.1768 14.3907L8.87386 17.6937C8.23851 18.329 7.20841 18.329 6.57306 17.6937C5.93771 17.0583 5.93771 16.0282 6.57306 15.3929L9.87603 12.0899L6.5474 8.76127C5.94319 8.15705 5.94319 7.17742 6.5474 6.5732C7.15162 5.96898 8.13126 5.96898 8.73548 6.5732L12.0641 9.90182L15.3928 6.57312Z",
    fill: "#FF8C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cccf3995e96e9764661e9b35d18f6619.svg";
export { ForwardRef as ReactComponent };